import { useEffect } from "react";
import { isEqual } from "lodash";
var EventListFilterListener = function (_a) {
    var _b, _c, _d, _e;
    var values = _a.values, initialValues = _a.initialValues, setValues = _a.setValues, setInitialValues = _a.setInitialValues;
    useEffect(function () {
        if (!isEqual(values, initialValues)) {
            setInitialValues(values);
            setValues(values);
        }
    }, [
        values.search,
        (_b = values.dateRange) === null || _b === void 0 ? void 0 : _b.startsat,
        (_c = values.dateRange) === null || _c === void 0 ? void 0 : _c.endsat,
        initialValues.search,
        (_d = initialValues.dateRange) === null || _d === void 0 ? void 0 : _d.startsat,
        (_e = initialValues.dateRange) === null || _e === void 0 ? void 0 : _e.endsat,
    ]);
    return null;
};
export default EventListFilterListener;
